var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-task-delivery-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var isPreview = ref.isPreview;
    var isLoading = ref.isLoading;
    var isDelivering = ref.isDelivering;
    var deliverTask = ref.deliverTask;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
    var goToExitRoute = ref.goToExitRoute;
    var task = ref.task;
    var brandNetworks = ref.brandNetworks;
    var uploadContentUrl = ref.uploadContentUrl;
    var uploadedContentDeliveryUrl = ref.uploadedContentDeliveryUrl;
    var deleteUploadedContentUrl = ref.deleteUploadedContentUrl;
    var handleFileChange = ref.handleFileChange;
    var handleResetUploads = ref.handleResetUploads;
    var handleUploadFailed = ref.handleUploadFailed;
    var uploadHeaders = ref.uploadHeaders;
    var uploadedFiles = ref.uploadedFiles;
    var hasUploadedFiles = ref.hasUploadedFiles;
    var isFileUploading = ref.isFileUploading;
    var isTaskContentLoading = ref.isTaskContentLoading;
    var taskContent = ref.taskContent;
    var quantityString = ref.quantityString;
    var goBack = ref.goBack;
return [_c('activation-brief-task-delivery-view',{attrs:{"is-loading":isLoading,"is-delivering":isDelivering,"errors":errors,"error-message":errorMessage,"task":task,"brand-networks":brandNetworks,"upload-content-url":uploadContentUrl,"uploaded-content-delivery-url":uploadedContentDeliveryUrl,"delete-uploaded-content-url":deleteUploadedContentUrl,"upload-headers":uploadHeaders,"uploaded-files":uploadedFiles,"has-uploaded-files":hasUploadedFiles,"is-file-uploading":isFileUploading,"is-task-content-loading":isTaskContentLoading,"task-content":taskContent,"quantity-string":quantityString},on:{"file-change":handleFileChange,"reset-uploads":handleResetUploads,"upload-failed":handleUploadFailed,"deliver":deliverTask,"exit":goToExitRoute,"back":goBack}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }